import { createSelector } from '@ngrx/store';

import { betslipSelector } from '../../base/store/selectors';
import { selectRewardTokens } from '../reward-tokens/selectors';

export const overAskStateSelector = createSelector(betslipSelector, (state) => state.overAskState);
export const overAskFlowStateSelector = createSelector(overAskStateSelector, (state) => state.flowState);
export const overAskFlowRemainingSecondsSelector = createSelector(overAskStateSelector, (state) => state.reviewState.remainingSeconds);
export const overAskBetsSelector = createSelector(betslipSelector, (state) => state.overAskState.bets);
export const overAskBetsInputSelector = createSelector(overAskBetsSelector, selectRewardTokens, (bets, tokens) => ({ bets, tokens }));
